
import type {
  UserEntity,
} from '@dinosave/core/types';
import AuthenticationForm from '@/components/AuthenticationForm';
import {
  Modal,
} from '@/components/Modals';
import type {
  ModalProps,
} from '@/components/Modals';

import styles from './AuthenticationModal.module.css';

type AuthenticationModalProps = ModalProps & {
   onSuccess?: (user: UserEntity) => void;
}

const AuthenticationModal = (props: AuthenticationModalProps) => {
  // ##########################################################################
  // PROPS
  // ##########################################################################

  const {
    onClose,
    onSuccess,
  } = props;

  // ##########################################################################
  // FUNCTIONS
  // ##########################################################################

  const handleSuccess = (user: UserEntity) => {
    if (
      onSuccess
    ) onSuccess(user);

    onClose();
  };

  // ##########################################################################
  // RENDER
  // ##########################################################################

  return (
    <Modal
      {...props}
      className={styles.authenticationModal}
      contentClassName={styles.content}
      closable
    >
      <AuthenticationForm
        kind="flat"
        onSuccess={handleSuccess}
      />
    </Modal>
  );
};

export default AuthenticationModal;
